import Typography from '@material-ui/core/Typography';
import { FC, memo } from 'react';

import { ILocationGroupClient } from '~/services/api/clientAllocation/types';

import AllocationMemberClientForm from './AllocationMemberClientForm';

import styles from '../../AccordionMembers.module.scss';

interface AccordionMemberGroupFormProps {
  watchedClients: number[];
  formFieldName: string;
  selectedClientsByLocationGroup: Record<string, ILocationGroupClient[]>;
  handleRemoveClientInLocationGroup: (id: number, field: string, groupName?: string) => void;
  isGlobalUser: boolean;
  memberId: number;
}

const AccordionMemberGroupForm: FC<AccordionMemberGroupFormProps> = ({
  selectedClientsByLocationGroup,
  handleRemoveClientInLocationGroup,
  watchedClients,
  formFieldName,
  isGlobalUser,
  memberId,
}) => {
  const removeClients = (id: number, groupName: string) => {
    handleRemoveClientInLocationGroup(id, formFieldName, groupName);
  };

  return (
    <>
      {Object.keys(selectedClientsByLocationGroup).map(groupName => {
        const clients = selectedClientsByLocationGroup[groupName];

        return (
          <div key={groupName}>
            <Typography variant="subtitle1" className={styles.assignedClientsTitle}>
              {groupName}
            </Typography>

            {clients
              .filter(client => watchedClients.includes(client.id))
              .map(client => (
                <AllocationMemberClientForm
                  key={client.id}
                  clientName={client.name}
                  isGlobalUser={isGlobalUser}
                  clientPhoto={client.photo}
                  clientId={client.id}
                  teams={isGlobalUser && client.teams.length > 0 ? client.teams : undefined}
                  fieldNameMemberId={formFieldName}
                  handleRemoveClient={id => removeClients(id, groupName)}
                  memberId={memberId}
                  validateAvailability
                />
              ))}
          </div>
        );
      })}
    </>
  );
};

export default memo(AccordionMemberGroupForm);
